var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.filePath)?_c('img',{class:_vm.$style.credIcon,attrs:{"src":_vm.filePath}}):(_vm.relevantNode)?_c('NodeIcon',{attrs:{"nodeType":_vm.relevantNode,"size":28}}):_c('span',{class:_vm.$style.fallback})],1)}
var staticRenderFns = []

export { render, staticRenderFns }